export default {
  parent: "#E06AA4",
  staff: "#6BBF6C",
  pupils: "#14c0e8",
};
